<template>
    <!-- <div  class="  banner" v-if="data">
      <router-link
      
        :to="
       
           data.link
           
        "
        
        class="overflow-hidden"
      >
      
        <img loading="lazy"  :src="data.picture" class="w-100 h-100" alt="" />
      </router-link>
    </div> -->
    <div class="banner" v-if="data">
    
      <DynamicLinker :item="data"  class="overflow-hidden">
        <img loading="lazy" :src="data.picture" class="w-100 h-100" alt="">
      </DynamicLinker>
    </div>
  </template>
  
  <script>
  import findUrl from "@/libraries/links/LinkResolver";
  import DynamicLinker from "../shared/DynamicLinker.vue";
  export default {
    name: "Baner",
  components: {DynamicLinker},

    props: {
      data: Object
     
    },
    methods: {
      findUrl,
    },
    computed: {
      // hasAnyBanners() {
      //   let ok = false;
      //   this.banners.every(banner => {
      //     if (banner) {
      //       ok = true
      //       return false;
      //     }
      //     return true
      //   })
      //   return ok;
      // }
    }
  };
  </script>
  
  <style scoped>
 .banner{
  border-radius: 16px;
  overflow: hidden;
 }
  .banners > a {
    /* max-height: 209px; */
  }
   </style>
  